import Typography from "@/components/Typography/Typography";
import { UserIcon } from "@/components/icon";

const airxProcurmentTeam = {
  name: "AIRX Procurement Team",
  phone: "+442039001921",
  email: "procurement@airxtechnologies.com",
};
const airxQuotestTeam = {
  name: "AIRX Quotes Team",
  phone: "+4402039001921",
  email: "quotes@airxtechnologies.com",
};

interface AIRXContactSectionProps {
  source: "customer" | "vendor";
}
export default function AirxContactSection({
  source,
}: AIRXContactSectionProps) {
  const contactData =
    source === "customer" ? airxQuotestTeam : airxProcurmentTeam;
  return (
    <div className="bg-white rounded-lg h-[330px] flex flex-col flex-shrink-0 justify-between w-[256px]">
      <Typography
        type="p"
        py={8}
        textAlign="center"
        fontFamily="font-kanit"
        uppercase
        textColor="primary"
        customStyles="bg-primaryDim rounded-t-lg text-center"
      >
        AIRX contact
      </Typography>
      <div className="flex items-center justify-center flex-col py-5">
        <div className="rounded-full text-primary bg-primaryDim max-w-[111px]">
          <UserIcon width={"111"} height="111" />
        </div>
        <Typography mt={5} type="p" fontFamily="font-kanit" textColor="black">
          {contactData.name}
        </Typography>
      </div>
      <div className="pb-5 px-2 flex flex-col gap-2">
        <Typography
          px={5}
          type="p"
          fontFamily="font-kanit"
          textColor="black"
          customStyles="flex flex-col"
          fontSize={14}
        >
          <Typography type="span" textColor="blackTransparent-60">
            Phone:
          </Typography>
          <a href={`tel:${contactData.phone}`}>
            <Typography
              mt={5}
              type="p"
              fontFamily="font-kanit"
              textColor="black"
            >
              {contactData.phone}
            </Typography>
          </a>
        </Typography>
        <Typography
          px={5}
          type="p"
          fontFamily="font-kanit"
          textColor="black"
          customStyles="flex flex-col"
          fontSize={14}
        >
          <Typography type="span" textColor="blackTransparent-60">
            Email:
          </Typography>

          <a href={`mailto:${contactData.email}`}>
            <Typography type="span">{contactData.email}</Typography>
          </a>
        </Typography>
      </div>
    </div>
  );
}
